import { render, staticRenderFns } from "./EventsDownloadCertificate.vue?vue&type=template&id=eda97880&"
import script from "./EventsDownloadCertificate.vue?vue&type=script&lang=js&"
export * from "./EventsDownloadCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports